import { stringifyEntityRef } from '@backstage/catalog-model';
import { useTechDocsReaderPage } from '@backstage/plugin-techdocs-react';
import {
  DocFeedbackCategory,
  normalizeDocPagePath,
} from '@internal/backstage-plugin-doc-feedback-common';
import { useCallback } from 'react';
import { useParams } from 'react-router-dom';

/**
 * Window event used by the "Was this page helpful?" bar (rendered inside the
 * docs shadow DOM) to open the feedback dialog owned by the subheader addon.
 */
export const OPEN_FEEDBACK_EVENT = 'devhub:doc-feedback:open';

export type OpenFeedbackEventDetail = {
  category?: DocFeedbackCategory;
};

export function openFeedbackDialog(detail: OpenFeedbackEventDetail = {}) {
  window.dispatchEvent(
    new CustomEvent<OpenFeedbackEventDetail>(OPEN_FEEDBACK_EVENT, { detail }),
  );
}

/** Identifies the doc page currently displayed in the TechDocs reader. */
export function useDocPage() {
  const { entityRef, shadowRoot, title } = useTechDocsReaderPage();
  const params = useParams();
  const ref = stringifyEntityRef(entityRef).toLocaleLowerCase('en-US');
  const pagePath = normalizeDocPagePath(params['*']);

  const getPageTitle = useCallback((): string | undefined => {
    const heading = shadowRoot?.querySelector('.md-content h1');
    const text = heading?.textContent?.replace(/¶\s*$/, '').trim();
    return text || title || undefined;
  }, [shadowRoot, title]);

  return { entityRef: ref, pagePath, getPageTitle };
}
